module.exports = __webpack_public_path__ + "static/media/postamail-logo-confirm.ce1fa4ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/postamail-logo-confirm.png
// module id = 795
// module chunks = 0